export default __webpack_public_path__ + "static/media/FamilyNumber15.036c2b3f.svg";